<template>
   <div>
      <div class="d-flex justify-content-between align-items-center pt-4">
         <p @click="onStepChange(1)" class="stage-name">Permitted Purpose</p>
         <p @click="onStepChange(2)" class="stage-name stage-2">Technological in Nature</p>
         <p @click="onStepChange(3)" class="stage-name stage-3">Elimination of Uncertainty</p>
         <p @click="onStepChange(4)" class="stage-name">Process of Experimentation</p>
         <p @click="onStepChange(5)" class="stage-name">Conclusion</p>
         <p @click="onStepChange(6)" class="stage-name invisible">Conclusion</p>
      </div>
      <div class="d-flex align-items-center">
         <b-icon
            v-if="stage > 1"
            @click="onStepChange(1)"
            icon="check-circle-fill"
            class="checkmark-circle"
         ></b-icon>
         <div v-else-if="stage === 1" class="current-circle" @click="onStepChange(1)"></div>
         <div v-else class="empty-circle" @click="onStepChange(1)"></div>
         <div class="connector" :class="{'connector--grayed-out': stage < 2}"></div>
         <b-icon
            v-if="stage > 2"
            @click="onStepChange(2)"
            icon="check-circle-fill"
            class="checkmark-circle"
         ></b-icon>
         <div v-else-if="stage === 2" class="current-circle" @click="onStepChange(2)"></div>
         <div v-else class="empty-circle" @click="onStepChange(2)"></div>
         <div class="connector" :class="{'connector--grayed-out': stage < 3}"></div>
         <b-icon
            v-if="stage > 3"
            @click="onStepChange(3)"
            icon="check-circle-fill"
            class="checkmark-circle"
         ></b-icon>
         <div v-else-if="stage === 3" class="current-circle" @click="onStepChange(3)"></div>
         <div v-else class="empty-circle" @click="onStepChange(3)"></div>
         <div class="connector" :class="{'connector--grayed-out': stage < 4}"></div>
         <b-icon
            v-if="stage > 4"
            icon="check-circle-fill"
            class="checkmark-circle"
            @click="onStepChange(4)"
         ></b-icon>
         <div v-else-if="stage === 4" class="current-circle" @click="onStepChange(4)"></div>
         <div v-else class="empty-circle" @click="onStepChange(4)"></div>
         <div class="connector" :class="{'connector--grayed-out': stage < 5}"></div>
         <b-icon
            v-if="stage > 5"
            icon="check-circle-fill"
            class="checkmark-circle"
            @click="onStepChange(5)"
         ></b-icon>
         <div v-else-if="stage === 5" class="current-circle" @click="onStepChange(5)"></div>
         <div v-else class="empty-circle" @click="onStepChange(5)"></div>
         <div class="connector connector--grayed-out"></div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'GetStartedProgress',

   props: {
      stage: Number,
   },

   methods: {
      onStepChange(step) {
         this.$emit('stepChanged', step);
      },
   },
};
</script>

<style scoped lang="scss">
.connector {
   height: 3px;
   width: 100%;
   background-color: $primary;

   &--grayed-out {
      background-color: #d9d9d9;
   }
}

.checkmark-circle {
   fill: $primary;
   width: 1.25rem;
   height: 1.25rem;

   &:hover {
      cursor: pointer;
   }
}

.stage-name {
   font-size: 0.8125rem;

   &:hover {
      cursor: pointer;
   }
}

.current-circle {
   width: 6.7rem;
   height: 1.25rem;
   background: $primary;
   border-radius: 50%;

   &:hover {
      cursor: pointer;
   }
}

.empty-circle {
   width: 6.7rem;
   height: 1.25rem;
   background: #d9d9d9;
   border-radius: 50%;

   &:hover {
      cursor: pointer;
   }
}

.stage-2 {
   margin-left: 3rem;
}

.stage-3 {
   margin-left: 1rem;
}
</style>
